export default "__VITE_ASSET__aaf3bc72__"